import { render, staticRenderFns } from "./TagsSectionV2026.vue?vue&type=template&id=5be9419d&scoped=true"
import script from "./TagsSectionV2026.vue?vue&type=script&lang=js"
export * from "./TagsSectionV2026.vue?vue&type=script&lang=js"
import style0 from "./TagsSectionV2026.vue?vue&type=style&index=0&id=5be9419d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be9419d",
  null
  
)

export default component.exports